export default "__VITE_ASSET__95a06ff4__"